import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app";
import "./app/main.src.css";

const container = document.getElementById("root");
if (!container) throw new Error("Furistic landing root element is missing");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
